<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}"><common-data name="appShortName_26"/>介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                面向专业投资者，基于财务分析，提供多因子估值图表，利润滤镜、风险甄别、EVA分析等风险研究工具...
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">5E基础版</p>
            <p>个股研究：提供小文财报、小文诊股、小文潜力股、财务画像、利润滤镜、风险甄别、EVA分析、股息率统计等功能，为研判股票价格提供参考。</p>
            <p>大盘研究：提供基本面分析和板块化分析功能，辅助把握市场方向，规避系统性风险。</p>
            <p>自选股票池研究：提供权益K线图与评分排名功能，帮助构建与优化投资组合。</p>
            <a target="_blank" href="https://wh5.wenhua.com.cn/#/buy">>>> 查看5E基础版更多功能</a>
            <!-- <br>
            <br>
            <p class="detail_title">量化投研</p>
            <p class="tent">量化编写平台：python语言平台，配合文华数据库，编写自由，数据丰富，云计算技术保证运算速度，提高研发效率。</p>
            <p class="tent">文华精选因子库：包含了基本面、市场交易和情绪3个大类14个子类的400多个精选因子。覆盖了当前量化领域的常见因子并持续更新。</p>
            <p class="tent">多因子策略：实现因子库和量化投资方法的融合，提供高效灵活的图表化多因子量化投研、组合优化管理和归因分析。</p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wh5.wenhua.com.cn/#/home" target="_blank"><common-data name="appShortName_26"/></a>体验版了解软件基础功能。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用<common-data name="appShortName_26"/>的电脑配置要求：<br />
                · X86架构的4核CPU/8G内存（RAM），或更高配置；<br />
                · windows10、windows11等64位操作系统；
            </p>
            <p class="tent">4.建议用电信、联通宽带，其它宽带会有卡顿的问题。            </p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 255px;
}
.details_gn p.tent {
    
}
</style>